import { NotificationsState, reducer as NotificationReducer } from 'react-notification-system-redux';
import { Action, AnyAction, combineReducers, Dispatch, Reducer } from 'redux';
import { getType } from 'typesafe-actions';

import * as App from '../../common/services/app/';
import * as CommonAuthService from '../../common/services/auth/';
import * as Customer from '../../common/services/customer/';
import * as ErrorBoundary from '../../common/services/error-boundary/';
import * as Events from '../../common/services/events/';
import * as Offer from '../../common/services/offer/';
import * as Subscription from '../../common/services/subscription/';
import * as Tyre from '../../common/services/tyre/';

// The top-level state object
export interface RootState {
    appState: App.Types.AppState;
    customerState: Customer.Types.CustomerState;
    offerState: Offer.Types.OfferState;
    subscriptionState: Subscription.Types.SubscriptionState;
    tyreState: Tyre.Types.TyreState;
    authState: CommonAuthService.Types.AuthState;
    errorBoundaryState: ErrorBoundary.Types.ErrorBoundaryState;
    //
    notificationState: NotificationsState;
    eventsState: Events.Types.EventsState;
}

// Combine Reducers into one App Reducer
const AppReducer = combineReducers<RootState>({
    appState: App.Reducer.default,
    customerState: Customer.Reducer.default,
    offerState: Offer.Reducer.default,
    subscriptionState: Subscription.Reducer.default,
    tyreState: Tyre.Reducer.default,
    authState: CommonAuthService.Reducer.default,
    errorBoundaryState: ErrorBoundary.Reducer.default,
    //
    notificationState: NotificationReducer as Reducer<NotificationsState, AnyAction>,
    eventsState: Events.Reducer.default,
});

export type RootAction =
    App.Reducer.AppAction |
    Customer.Reducer.CustomerAction |
    Offer.Reducer.OfferAction |
    Subscription.Reducer.SubscriptionAction |
    Tyre.Reducer.TyreAction |
    CommonAuthService.Reducer.AuthAction |
    ErrorBoundary.Reducer.ErrorBoundaryAction |
    Events.Reducer.EventsAction
    ;
// Additional props for connected React components. This prop is passed by default with `connect()`
export interface ConnectedReduxProps<A extends Action = AnyAction> {
    dispatch: Dispatch<A>;
}

// Wrap AppReducer into a RootReducer. This will enable us to clear all the store when certain actions are triggered (ex: logout)
const invalidateStateActions = [
    getType(CommonAuthService.Actions.logoutUserSuccess),
    getType(CommonAuthService.Actions.getnewAccessTokenFailure),
    getType(CommonAuthService.Actions.useNewAccessTokenFailure),
];

const RootReducer: Reducer<RootState, AnyAction> = (state, action) => {
    return AppReducer(invalidateStateActions.indexOf(action.type) > -1 ? {
        ...AppReducer({} as any, {} as any),
    } : state, action);
};

export default RootReducer;
